import { render, staticRenderFns } from "./FarmFormView.vue?vue&type=template&id=67c01756&"
import script from "./FarmFormView.vue?vue&type=script&lang=ts&"
export * from "./FarmFormView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports